import React from "react";
import "../style/About.css";
import react from "../images/react_icon.png";
import solidity from "../images/solidity_icon.png";
import ethereum from "../images/ethereum_icon.png";
import python from "../images/python_icon.png";
import { motion } from "framer-motion";

function About({ setMode }) {
  return (
    <motion.div
      className={`about_container + about_${setMode[1]}`}
      style={{
        color: setMode[0],
      }}
    >
      <div className="about_head all_head1">
        <h1>ABOUT ME</h1>
      </div>
      <div className="about_body">
        <div className="left_about">
          <motion.div
            className="framework_logo"
            style={{ backgroundColor: setMode[4] }}
            // initial={{ x: -150 }}
            // whileInView={{ x: 0 }}
          >
            <div className="box">
              <motion.img
                src={react}
                alt=""
                initial={{ scale: 1 }}
                whileHover={{ scale: 1.2 }}
              />
            </div>
            <div className="box">
              <motion.img
                src={ethereum}
                alt=""
                initial={{ scale: 1 }}
                whileHover={{ scale: 1.2 }}
              />
            </div>
            <div className="box">
              <motion.img
                src={python}
                alt=""
                initial={{ scale: 1 }}
                whileHover={{ scale: 1.2 }}
              />
            </div>
            <div className="box">
              <motion.img
                src={solidity}
                alt=""
                initial={{ scale: 1 }}
                whileHover={{ scale: 1.2 }}
              />
            </div>
          </motion.div>
        </div>
        <div className="right_about">
          <motion.div
            className="window_close_box"
            style={{
              borderColor: setMode[2],
              backgroundColor: setMode[3],
            }}
          >
            <div className="dot_container">
              <div className="red dot"></div>
              <div className="yellow dot"></div>
              <div className="green dot"></div>
            </div>
            <div
              className="window_box"
              style={{
                borderColor: setMode[2],
                color: setMode[0],
                backgroundColor: setMode[3],
              }}
            >
              <h3 className="all_head3">Hi :)</h3>
              <p className="all_para" style={{ color: setMode[0] }}>
                I'm Maaz, a 19-year-old student living in India. I completed my
                high school studies at St Aloysius school in 2021 🎓. I really
                love to make websites and blockchain apps. I am currently a
                freelancer at Upwork, pretty new to the field. Designing
                websites as a front-end developer is super cool for me. You'd
                have to choose the right colors, font, layouts, and stuff.
                Blockchain is a very new technology and it has lots of use in
                our world. I chose to become a blockchain developer as it
                excites me so much 😃. Major programming languages I know are
                JavaScript, solidity, and python. I developed many cool projects
                with python. Some of those are two games 🕹️ from scratch and an
                AI Aquila 🤖 which took a lot of effort and time. All projects
                are listed below.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
}

export default About;
